export default "__VITE_ASSET__D3IS2Tfr__";